import React from "react";
import {formatNumber, formatPercent} from "./format.js";
import {formatPallets} from "./inventoryStrategyShared.jsx";
import {palletsNeed} from "./LagerplaetzeLayout.js";

/**
 * Detail-Tooltip beim Überfahren (bzw. Fokussieren oder Antippen) eines
 * Sortiment-Blocks in der Lagerplätze-Grafik. Eine einzelne, per
 * Mausposition platzierte Instanz statt einer Overlay-Instanz je Block - bei
 * mehreren hundert Blöcken performanter und einfacher zu positionieren.
 *
 * Auf Touch-Geräten gibt es kein Mouseleave, das den Tooltip nach dem
 * Antippen wieder schließt - deshalb trägt er eine eigene Schließen-
 * Schaltfläche (`onClose`), die auch bei einem angetippten Block
 * funktioniert.
 */
export default function LagerplaetzeTooltip({hover, onClose}) {
    if (!hover) {
        return null;
    }
    const {row, warehouse, capacityPallets, x, y} = hover;
    const share = capacityPallets > 0 ? (palletsNeed(row) / capacityPallets) * 100 : 0;

    return (
        <div
            className="position-fixed bg-white border rounded-2 shadow-lg p-2 small"
            style={{left: x + 16, top: y + 16, zIndex: 4000, maxWidth: 280}}
            role="status"
        >
            <div className="d-flex align-items-start justify-content-between gap-2">
                <div className="fw-semibold">{row.parent_name || "Ohne Bezeichnung"}</div>
                {onClose && (
                    <button
                        type="button"
                        className="btn-close"
                        aria-label="Schließen"
                        style={{fontSize: "0.65rem"}}
                        onClick={onClose}
                    />
                )}
            </div>
            <div className="text-muted mb-1">
                Übernummer {row.parent_article_number} · {row.article_group || "Ohne Warengruppe"}
            </div>
            <table className="mb-0">
                <tbody>
                    <tr>
                        <td className="pe-3 text-muted">Empfohlen</td>
                        <td className="text-end fw-semibold">{formatPallets(palletsNeed(row))}</td>
                    </tr>
                    <tr>
                        <td className="pe-3 text-muted">Aktuell belegt</td>
                        <td className="text-end fw-semibold">{formatPallets(row.pallets_current)}</td>
                    </tr>
                    <tr>
                        <td className="pe-3 text-muted">Artikel</td>
                        <td className="text-end fw-semibold">{formatNumber(row.article_count)}</td>
                    </tr>
                    <tr>
                        <td className="pe-3 text-muted">Anteil {warehouse?.name}</td>
                        <td className="text-end fw-semibold">{formatPercent(share)}</td>
                    </tr>
                    {row.rowNumber !== undefined && (
                        <tr>
                            <td className="pe-3 text-muted">Regalreihe</td>
                            <td className="text-end fw-semibold">
                                {row.rowNumber} (Modul {row.moduleIndex + 1}, {row.side === "vorne" ? "vordere" : "hintere"} Reihe)
                            </td>
                        </tr>
                    )}
                    {row.levels !== undefined && (
                        <tr>
                            <td className="pe-3 text-muted">Ebenen</td>
                            <td className="text-end fw-semibold">verteilt auf alle {row.levels}</td>
                        </tr>
                    )}
                </tbody>
            </table>
        </div>
    );
}
